class QueryCanvasHelper {
    static blobToBase64(data: Blob) {
        return new Promise<string>((resolve, reject) => {
            let reader = new FileReader();
            reader.readAsDataURL(data);
            reader.onload = () => {
                resolve(reader.result as string);
            }
        })
    }

    static loadImage(url: string, width: number, height: number) {
        return new Promise<HTMLImageElement>((resolve, reject) => {
            let image = new Image(width, height);

            image.addEventListener('load', () => {
                resolve(image);
            });
            image.addEventListener('error', (ev) => {
                reject(ev);
            });
            image.src = url;
        });
    }
}